import { render, staticRenderFns } from "./questionItemManage.vue?vue&type=template&id=c423ccd8&scoped=true"
import script from "./questionItemManage.vue?vue&type=script&lang=js"
export * from "./questionItemManage.vue?vue&type=script&lang=js"
import style0 from "./questionItemManage.vue?vue&type=style&index=0&id=c423ccd8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c423ccd8",
  null
  
)

export default component.exports